"use strict";

/**
 * Character class utilities for XML NS 1.0 edition 3.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
//
// Fragments.
//
// tslint:disable-next-line:max-line-length
exports.NC_NAME_START_CHAR = "A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
exports.NC_NAME_CHAR = "-" + exports.NC_NAME_START_CHAR + ".0-9\xB7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
exports.NC_NAME_START_CHAR_RE = new RegExp("^[" + exports.NC_NAME_START_CHAR + "]$", "u");
exports.NC_NAME_CHAR_RE = new RegExp("^[" + exports.NC_NAME_CHAR + "]$", "u");
exports.NC_NAME_RE = new RegExp("^[" + exports.NC_NAME_START_CHAR + "][" + exports.NC_NAME_CHAR + "]*$", "u");
/**
 * Determines whether a codepoint matches [[NC_NAME_START_CHAR]].
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches.
 */
// tslint:disable-next-line:cyclomatic-complexity
function isNCNameStartChar(c) {
  return c >= 0x41 && c <= 0x5A || c === 0x5F || c >= 0x61 && c <= 0x7A || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x200C && c <= 0x200D || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
exports.isNCNameStartChar = isNCNameStartChar;
/**
 * Determines whether a codepoint matches [[NC_NAME_CHAR]].
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches.
 */
function isNCNameChar(c) {
  return isNCNameStartChar(c) || c === 0x2D || c === 0x2E || c >= 0x30 && c <= 0x39 || c === 0x00B7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
exports.isNCNameChar = isNCNameChar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3htbG5zLzEuMC9lZDMudHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXSwibWFwcGluZ3MiOiI7O0FBQUE7Ozs7Ozs7Ozs7QUFRQTtBQUNBO0FBQ0E7QUFFQTtBQUNhLDBCQUFrQixHQUFHLHVLQUEySztBQUVoTSxvQkFBWSxHQUN2QixNQUFJLDBCQUFrQix1Q0FBc0M7QUFFOUQ7QUFDQTtBQUNBO0FBRWEsNkJBQXFCLEdBQ2hDLElBQUksTUFBTSxDQUFDLE9BQUssMEJBQWtCLE9BQUksRUFBRSxHQUFHLENBQUM7QUFFakMsdUJBQWUsR0FBRyxJQUFJLE1BQU0sQ0FBQyxPQUFLLG9CQUFZLE9BQUksRUFBRSxHQUFHLENBQUM7QUFFeEQsa0JBQVUsR0FDckIsSUFBSSxNQUFNLENBQUMsT0FBSywwQkFBa0IsVUFBSyxvQkFBWSxRQUFLLEVBQUUsR0FBRyxDQUFDO0FBRWhFOzs7Ozs7O0FBT0E7QUFDQSxTQUFnQixpQkFBaUIsQ0FBQyxDQUFTO0VBQ3pDLE9BQVMsQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLElBQUksSUFBSSxJQUN2QixDQUFDLEtBQUssSUFBSSxJQUNULENBQUMsSUFBSSxJQUFJLElBQUksQ0FBQyxJQUFJLElBQUssSUFDdkIsQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLElBQUksSUFBSyxJQUN2QixDQUFDLElBQUksSUFBSSxJQUFJLENBQUMsSUFBSSxJQUFLLElBQ3ZCLENBQUMsSUFBSSxNQUFNLElBQUksQ0FBQyxJQUFJLE1BQU8sSUFDM0IsQ0FBQyxJQUFJLE1BQU0sSUFBSSxDQUFDLElBQUksTUFBTyxJQUMzQixDQUFDLElBQUksTUFBTSxJQUFJLENBQUMsSUFBSSxNQUFPLElBQzNCLENBQUMsSUFBSSxNQUFNLElBQUksQ0FBQyxJQUFJLE1BQU8sSUFDM0IsQ0FBQyxJQUFJLE1BQU0sSUFBSSxDQUFDLElBQUksTUFBTyxJQUMzQixDQUFDLElBQUksTUFBTSxJQUFJLENBQUMsSUFBSSxNQUFPLElBQzNCLENBQUMsSUFBSSxNQUFNLElBQUksQ0FBQyxJQUFJLE1BQU8sSUFDM0IsQ0FBQyxJQUFJLE1BQU0sSUFBSSxDQUFDLElBQUksTUFBTyxJQUMzQixDQUFDLElBQUksTUFBTSxJQUFJLENBQUMsSUFBSSxNQUFPLElBQzNCLENBQUMsSUFBSSxPQUFPLElBQUksQ0FBQyxJQUFJLE9BQVE7QUFDeEM7QUFoQkE7QUFrQkE7Ozs7Ozs7QUFPQSxTQUFnQixZQUFZLENBQUMsQ0FBUztFQUNwQyxPQUFPLGlCQUFpQixDQUFDLENBQUMsQ0FBQyxJQUN4QixDQUFDLEtBQUssSUFBSSxJQUNWLENBQUMsS0FBSyxJQUFJLElBQ1QsQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLElBQUksSUFBSyxJQUN4QixDQUFDLEtBQUssTUFBTSxJQUNYLENBQUMsSUFBSSxNQUFNLElBQUksQ0FBQyxJQUFJLE1BQU8sSUFDM0IsQ0FBQyxJQUFJLE1BQU0sSUFBSSxDQUFDLElBQUksTUFBUTtBQUNsQztBQVJBIiwiaWdub3JlTGlzdCI6W119